import type { VoidFunctionComponent } from 'react';

import Loader from '../../../generic/Loader';

import styles from './Loading.module.less';

/**
 * Renders the "Loading" state of the Test Dependency card, which is shown
 * while FOSSA is validating the provided dependency revision.
 */
const Loading: VoidFunctionComponent = () => {
  return (
    <div className={styles.loading}>
      <Loader />
    </div>
  );
};

export default Loading;
